import { Link } from 'react-router-dom'

const cards = [
  {
    to: '/admin/invite',
    title: 'Invite User',
    description: 'Send an invitation to a new team member and assign their role.',
    color: 'border-blue-200 dark:border-blue-800 hover:border-blue-400 dark:hover:border-blue-600',
    headerColor: 'bg-blue-50 dark:bg-blue-900/30',
    iconColor: 'text-blue-600 dark:text-blue-400',
  },
  {
    to: '/admin/users',
    title: 'Manage Users',
    description: 'View, edit roles, and activate or deactivate user accounts.',
    color: 'border-purple-200 dark:border-purple-800 hover:border-purple-400 dark:hover:border-purple-600',
    headerColor: 'bg-purple-50 dark:bg-purple-900/30',
    iconColor: 'text-purple-600 dark:text-purple-400',
  },
  {
    to: '/admin/groups',
    title: 'User Groups',
    description: 'Manage permission groups and assign permissions to roles.',
    color: 'border-indigo-200 dark:border-indigo-800 hover:border-indigo-400 dark:hover:border-indigo-600',
    headerColor: 'bg-indigo-50 dark:bg-indigo-900/30',
    iconColor: 'text-indigo-600 dark:text-indigo-400',
  },
  {
    to: '/admin/branches',
    title: 'Manage Branches',
    description: 'Configure CY UK branch offices — BHX (Birmingham) and LHR (Slough).',
    color: 'border-green-200 dark:border-green-800 hover:border-green-400 dark:hover:border-green-600',
    headerColor: 'bg-green-50 dark:bg-green-900/30',
    iconColor: 'text-green-600 dark:text-green-400',
  },
  {
    to: '/admin/company-settings',
    title: 'Company Settings',
    description: 'CY UK legal name, address, phone, company number and BIFA text — the single source every letterhead/PDF reads from.',
    color: 'border-green-200 dark:border-green-800 hover:border-green-400 dark:hover:border-green-600',
    headerColor: 'bg-green-50 dark:bg-green-900/30',
    iconColor: 'text-green-600 dark:text-green-400',
  },
  {
    to: '/admin/ci-parser',
    title: 'CI PDF Parser',
    description: 'Choose which AI (Gemini or Anthropic) reads Commercial Invoice PDFs, and compare both side by side on a real PDF.',
    color: 'border-indigo-200 dark:border-indigo-800 hover:border-indigo-400 dark:hover:border-indigo-600',
    headerColor: 'bg-indigo-50 dark:bg-indigo-900/30',
    iconColor: 'text-indigo-600 dark:text-indigo-400',
  },
  {
    to: '/admin/audit-log',
    title: 'Audit Log',
    description: 'View a full history of all creates, updates, and deletes across key business tables.',
    color: 'border-gray-200 dark:border-gray-700 hover:border-gray-400 dark:hover:border-gray-500',
    headerColor: 'bg-gray-50 dark:bg-gray-700/50',
    iconColor: 'text-gray-600 dark:text-gray-300',
  },
  {
    to: '/admin/sage',
    title: 'Connect Sage',
    description: 'Connect to Sage Business Cloud Accounting and manage the sync connection.',
    color: 'border-teal-200 dark:border-teal-800 hover:border-teal-400 dark:hover:border-teal-600',
    headerColor: 'bg-teal-50 dark:bg-teal-900/30',
    iconColor: 'text-teal-600 dark:text-teal-400',
  },
  {
    to: '/admin/sage-reference-data',
    title: 'Sage Reference Data',
    description: 'Map Ledger Account codes and VAT Rates to Sage\'s own ids, required for invoice/CSV import syncing.',
    color: 'border-teal-200 dark:border-teal-800 hover:border-teal-400 dark:hover:border-teal-600',
    headerColor: 'bg-teal-50 dark:bg-teal-900/30',
    iconColor: 'text-teal-600 dark:text-teal-400',
  },
  {
    to: '/admin/ecustoms',
    title: 'eCustoms (Descartes)',
    description: 'Enable direct API submission to Descartes once UAT testing is verified.',
    color: 'border-orange-200 dark:border-orange-800 hover:border-orange-400 dark:hover:border-orange-600',
    headerColor: 'bg-orange-50 dark:bg-orange-900/30',
    iconColor: 'text-orange-600 dark:text-orange-400',
  },
  // Z73.18 follow-up: NA Registry / Goods Locations moved to the Data dropdown ("Customs"
  // group) -- ordinary customs staff maintain these day to day, ADMIN-only access was too
  // restrictive. transport_modes/declaration_types/declaration_categories stay here: they're
  // static HMRC/CDS reference codes staff shouldn't be editing.
  {
    to: '/admin/customs-lookups/transport_modes',
    title: 'Transport Modes',
    description: 'UN/EDIFACT mode-of-transport codes used on eCustoms declarations.',
    color: 'border-orange-200 dark:border-orange-800 hover:border-orange-400 dark:hover:border-orange-600',
    headerColor: 'bg-orange-50 dark:bg-orange-900/30',
    iconColor: 'text-orange-600 dark:text-orange-400',
  },
  {
    to: '/admin/customs-lookups/declaration_types',
    title: 'Declaration Types',
    description: 'Box 1 declaration type codes (default IMD) used on eCustoms declarations.',
    color: 'border-orange-200 dark:border-orange-800 hover:border-orange-400 dark:hover:border-orange-600',
    headerColor: 'bg-orange-50 dark:bg-orange-900/30',
    iconColor: 'text-orange-600 dark:text-orange-400',
  },
  {
    to: '/admin/customs-lookups/declaration_categories',
    title: 'Declaration Categories',
    description: 'CDS declaration category codes (default H1) used on eCustoms declarations.',
    color: 'border-orange-200 dark:border-orange-800 hover:border-orange-400 dark:hover:border-orange-600',
    headerColor: 'bg-orange-50 dark:bg-orange-900/30',
    iconColor: 'text-orange-600 dark:text-orange-400',
  },
  {
    to: '/admin/pricing',
    title: 'Pricing',
    description: 'Customer rate cards, charge codes, and lanes — quote pricing by category and route.',
    color: 'border-emerald-200 dark:border-emerald-800 hover:border-emerald-400 dark:hover:border-emerald-600',
    headerColor: 'bg-emerald-50 dark:bg-emerald-900/30',
    iconColor: 'text-emerald-600 dark:text-emerald-400',
  },
  {
    to: '/admin/supplier-pricing',
    title: 'Supplier Pricing',
    description: 'What hauliers and couriers charge us — supplier rate cards by delivery method and postcode area.',
    color: 'border-emerald-200 dark:border-emerald-800 hover:border-emerald-400 dark:hover:border-emerald-600',
    headerColor: 'bg-emerald-50 dark:bg-emerald-900/30',
    iconColor: 'text-emerald-600 dark:text-emerald-400',
  },
]

export default function AdminIndex() {
  return (
    <div className="p-6 max-w-2xl mx-auto">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-800 dark:text-white">Admin</h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">System administration tools</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {cards.map(card => (
          <Link
            key={card.to}
            to={card.to}
            className={`block rounded-xl border-2 ${card.color} bg-white dark:bg-gray-800 overflow-hidden hover:shadow-md transition-all`}
          >
            <div className={`px-6 py-4 ${card.headerColor}`}>
              <span className={`text-lg font-semibold ${card.iconColor}`}>{card.title}</span>
            </div>
            <div className="px-6 py-4">
              <p className="text-sm text-gray-500 dark:text-gray-400">{card.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  )
}
